import React, { ReactElement } from 'react'
import styles from '../Filters.module.scss'
import { FilterChip } from 'components/SA/Filters'
import { getPriceLabel } from '../helpers'
import { SelectedFacetConnector, SelectedFacetConnectorProps } from 'connectors/Facets'
import { LocaleCurrency } from 'types/Shared/Locale'
import { SelectedFacets } from 'types/Facets'
import {
  OVERRIDE_STATUS_MAPPING_RULES,
  OVERRIDE_SORT_MAPPING_RULES,
  OVERRIDE_MATERIALS_MAPPING_RULES,
  OVERRIDE_ORIENTATION_MAPPING_RULES,
  OVERRIDE_IS_OUTDOOR_MAPPING_RULES,
} from 'components/SA/Facets/helpers/constants'
import { capitalizeString } from 'lib/helpers'
import { convertSizeUnit } from 'components/SA/Facets/helpers/facets'
import { MeasurementUnit } from 'types/User/Session'

type FacetTagParams = SelectedFacets & {
  selectedCurrency: LocaleCurrency
  measurementUnit: MeasurementUnit
}

const getFacetTag = ({
  facetName,
  title,
  attributeName,
  selectedCurrency,
  measurementUnit,
}: FacetTagParams) => {
  switch (facetName) {
    case 'color':
      return <div className={styles.colorFacet} style={{ backgroundColor: attributeName }} />

    case 'price':
    case 'prints_price_ranges':
      return getPriceLabel(selectedCurrency, title)

    case 'original_status':
      return OVERRIDE_STATUS_MAPPING_RULES[title]

    case 'size':
      const OVERRIDE_SIZE_MAPPING_RULES = convertSizeUnit(measurementUnit)
      return OVERRIDE_SIZE_MAPPING_RULES[title]

    case 'sort':
      return OVERRIDE_SORT_MAPPING_RULES[title]

    case 'materials':
    case 'prints_materials':
      return OVERRIDE_MATERIALS_MAPPING_RULES[title] || capitalizeString(title)

    case 'orientation':
      return OVERRIDE_ORIENTATION_MAPPING_RULES[title] || capitalizeString(title)

    case 'is_outdoor':
      return capitalizeString(OVERRIDE_IS_OUTDOOR_MAPPING_RULES[facetName])

    default:
      return capitalizeString(title)
  }
}

type Chip = SelectedFacets & {
  [key: string]: any
}

type ChipListFilterProps<T> = SelectedFacetConnectorProps & {
  facetsList: ReadonlyArray<T>
  onClose: (facet: T) => void
  onClearFilter: () => void
  isClearFilterVisible?: boolean
}

function ChipListFilter<T extends Chip>({
  facetsList,
  onClose,
  onClearFilter,
  isClearFilterVisible,
  selectedCurrency,
  measurementUnit,
}: ChipListFilterProps<T>): ReactElement<ChipListFilterProps<T>> {
  return (
    <div className={styles.chipListFilterContainer}>
      {facetsList?.length > 0 && isClearFilterVisible && (
        <button onClick={onClearFilter}>Clear All</button>
      )}
      {facetsList.map((facet) => (
        <FilterChip
          key={facet.title}
          title={getFacetTag({
            facetName: facet.facetName,
            title: facet.title,
            attributeName: facet.attributeName,
            selectedCurrency,
            measurementUnit,
          })}
          onClose={() => onClose(facet)}
        />
      ))}
    </div>
  )
}

export default SelectedFacetConnector(ChipListFilter)
